import styled from 'styled-components';
import { Subtitle1Styles } from '../../typography';
import { getColorShade, getSizeBy, getColor } from '../../../../src/styled/utils';
const getBorderRadius = (order) => {
    if (order === 'last') {
        return ({ theme }) => `0 ${getSizeBy(1.25)({ theme })} ${getSizeBy(1.25)({ theme })} 0`;
    }
    if (order === 'first') {
        return ({ theme }) => `${getSizeBy(1.25)({ theme })} 0 0 ${getSizeBy(1.25)({ theme })}`;
    }
    return 0;
};
const getBorderWidth = (order) => {
    if (order !== 'last' && order !== 'first') {
        return ({ theme }) => `${getSizeBy(0.25)({ theme })} 0 ${getSizeBy(0.25)({ theme })} 0`;
    }
    return ({ theme }) => getSizeBy(0.25)({ theme });
};
export const StyledSelectElement = styled.div `
  flex: ${({ isActive }) => (isActive ? 1.5 : 1)};
  padding: ${getSizeBy(2)} ${getSizeBy(4)};
  color: ${({ isActive }) => (isActive ? getColor('surface') : getColor('onSurface'))};
  background-color: ${({ isActive }) => isActive ? getColorShade('primary', 'highEmphasis') : 'transparent'};
  border: ${getSizeBy(0.25)} solid ${getColor('secondary')};
  border-width: ${({ order }) => getBorderWidth(order)};
  border-radius: ${({ order }) => getBorderRadius(order)};
`;
export const StyledButtonGroup = styled.div `
  display: flex;
  flex-direction: row;
  border: ${getSizeBy(0.5)} ${getColorShade('primary', 'border')};
`;
export const StyledLabel = styled.span `
  ${Subtitle1Styles};
`;
